import ProductTestRoute from 'hook/ProductTestRoute';
import { AdministrationPage, AuditPage, HomePage, LaboAdminPage, TestListPage } from 'pages';
import { TestPage } from 'pages/TestPage';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ROUTES } from 'utils/constants/routes';
import { LaboUserEditPage } from 'pages/LaboUserEditPage';
import { AccountPage } from 'pages/AccountPage';
import { LaboUserCreatePage } from 'pages/LaboUserCreatePage';


export const SubRoutes = () => {
  return (
    <Switch>
      <Route component={HomePage} path={ROUTES.HOME} />
      <Route component={AccountPage} path={ROUTES.ACCOUNT.BASE} />
      <Route component={TestListPage} exact  path={ROUTES.TESTS} />
      <Route component={AuditPage} path={ROUTES.AUDITS} />
      <Route component={LaboAdminPage} exact path={ROUTES.LABO_ADMIN.GENERAL} />
      <Route
        exact
        path={ROUTES.LABO_ADMIN.USER_CREATE}
        render={(props) =>
          <LaboUserCreatePage {...props} redirect={ROUTES.LABO_ADMIN.USER_EDIT}/>
        }
      />
      <Route
        exact
        path={ROUTES.ADMINISTRATION.USER_CREATE}
        render={(props) =>
          <LaboUserCreatePage {...props} redirect={ROUTES.ADMINISTRATION.USER_EDIT}/>
        }
      />
      <Route component={LaboUserEditPage} exact path={ROUTES.LABO_ADMIN.USER_EDIT} />
      <Route component={LaboUserEditPage} exact path={ROUTES.ADMINISTRATION.USER_EDIT} />
      <Route component={AdministrationPage} path={ROUTES.ADMINISTRATION.GENERAL} />
      <ProductTestRoute component={TestPage} path={ROUTES.TEST.BASE} />
      <Redirect from={ROUTES.BASE} to={ROUTES.HOME} />
    </Switch>
  );
};